<div class="loaderContent">
  @if (!this.isLoading2()) {
    <div class="light-shade box rounded-corners" style="width: 100%; max-width: 910px; margin-bottom: 10px; padding: 10px; box-sizing: border-box;">
      <table>
        <tr>
          <td colspan="3" style="font-weight: bold">Payment Information</td>
        </tr>
        <tr>
          <td style="width: 15px"></td>
          <td class="receipt-label-color">Payment Date and Time</td>
          <td>{{ payment?.entry_datetime | date: dateTimeFormat }}</td>
        </tr>
        <tr>
          <td></td>
          @if (isMotorist()) {
            <td class="receipt-label-color">Motorist ID and State</td>
          }
          @if (!isMotorist()) {
            <td class="receipt-label-color">License Plate and State</td>
          }

          <td>{{identity()}}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Entity Paid</td>
          <td>{{ site?.site_name }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Balance Paid</td>
          <td class="receipt-number">{{ payment?.payment_amount | currency: 'USD':'symbol' }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Service Fee</td>
          <td class="receipt-number">{{ payment?.payment_processing_charge | currency: 'USD':'symbol' }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Final Payment Amount</td>
          <td class="receipt-number">
            {{ payment?.payment_amount_plus_processing_charge | currency: 'USD':'symbol' }}
          </td>
        </tr>

        <tr>
          <td colspan="3">&nbsp;</td>
        </tr>

        <tr>
          <td colspan="3" style="font-weight: bold">Transaction Detail</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Receipt Number</td>
          <td>{{ payment?.receipt_number }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Authorization Code</td>
          <td>{{ payment?.cc_authorization_code }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Amount</td>
          <td class="receipt-number">
            {{ payment?.payment_amount_plus_processing_charge | currency: 'USD':'symbol' }}
          </td>
        </tr>
        <tr>
          <td colspan="3">
            <br />
            Thank you for your payment which has been powered for {{ site?.site_name }} by SureCourt LLC.<br /><br />
            This amount will appear on your credit card statement listed as {{site?.retail_descriptor}} and includes a
            service fee accepted and authorized by you. For questions or concerns regarding this transaction please
            click the “Business Contact Information” link.<br /><br />
            Transaction disputes or chargebacks may result in the reinstatement of the obligations paid in this
            transaction and in an additional charge for the cost of the dispute.
          </td>
        </tr>
        <tr>
          <td colspan="3">&nbsp;</td>
        </tr>

        <tr>
          <td colspan="3" style="font-weight: bold">Payment Information</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">First Name</td>
          <td>{{ payment?.cc_first_name_on_card }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Last Name</td>
          <td>{{ payment?.cc_last_name_on_card }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Billing Address</td>
          <td>{{ payment?.cc_address }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Billing City & State</td>
          <td>{{ payment?.cc_city }}, {{ payment?.cc_state }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Billing Zip</td>
          <td>{{ payment?.cc_zip }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">E-mail Address</td>
          <td>{{ payment?.cc_email }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Card Type</td>
          <td>{{ payment?.cc_card_type }}</td>
        </tr>
        <tr>
          <td></td>
          <td class="receipt-label-color">Card Number</td>
          <td>{{ payment?.card_number_last_four }}</td>
        </tr>

        <tr>
          <td colspan="3">&nbsp;</td>
        </tr>

        <tr>
          <td colspan="3" style="font-weight: bold">Tickets Paid</td>
        </tr>
        <tr>
          <td></td>
          <td colspan="3">
            <table>
              <tr>
                <td class="receipt-label-color" style="border-bottom: solid 1px black">Summons</td>
                <td class="receipt-label-color" style="border-bottom: solid 1px black">Amount Paid</td>
              </tr>

              @for (item of ticketList; track item) {
                <tr>
                  <td>{{ item.ticket_number }}</td>
                  <td class="receipt-number" style="text-align:right;">
                    {{ item.ticket_balance | currency: 'USD':'symbol' }}
                  </td>
                </tr>
              }
            </table>
          </td>
        </tr>
      </table>
      <div style="margin-top: 10px">
        <dx-button text="Search" (onClick)="Search()" icon="{{ env.assetsPath }}images/Search_16x16.png"></dx-button>
        <dx-button
          style="margin-left:10px;"
          text="Print"
          (onClick)="Print()"
        icon="{{ env.assetsPath }}images/Print_16x16.png"></dx-button>
      </div>
    </div>
  } @else {
    <app-loading-div></app-loading-div>
  }
</div>

